;(function() {
function websiteDisplayFilter() {
  return function(website) {
    if (!website) {
      return website;
    }

    return website.replace(/^https?:\/\/(?:www\.)?|^www\./i, "");
  }
}

angular.module("firmaren")
  .filter("websiteDisplay", websiteDisplayFilter);
}());
